import FlashLib from "flashlib_onlyplay";
import EntryPoint from '../libs/game-engine/src/EntryPoint';

export default class SlotFrameContainer extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);
  }
}
